import { render, staticRenderFns } from "./protocolOne.vue?vue&type=template&id=767cde77&"
var script = {}
import style0 from "./protocolOne.vue?vue&type=style&index=0&id=767cde77&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports